
import { FoodList } from "../FoodList/FoodList";

export function Lunch() {
  return <FoodList category="Lunch" />;
}
